/**
 * El atajo al DOM, en un sitio solo.
 *
 * Vivía dentro de `main.ts`. Salió de ahí el 23-oct-2026, cuando el creador de
 * personajes se movió a su propio trozo (`pantallaAvatar.ts`): las dos
 * pantallas lo necesitan, y una copia en cada fichero es una copia que un día
 * se separa.
 */

/**
 * Busca un elemento por su id y **falla ruidosamente si no está**.
 *
 * A propósito: un panel que no aparece porque le falta un id es muchísimo más
 * difícil de encontrar que un error en la consola con el nombre del id que
 * falta.
 */
export function el<T extends HTMLElement = HTMLElement>(id: string): T {
  const nodo = document.getElementById(id);
  if (!nodo) throw new Error(`falta el elemento #${id} en index.html`);
  return nodo as T;
}
